import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable, map, mergeMap, of, withLatestFrom } from 'rxjs';
import { AuthFacade } from '~backoffice/app/~store/facades/auth.facade';

export const AUTHENTICATED_GUARD = (
  route: ActivatedRouteSnapshot,
  next: RouterStateSnapshot
): Observable<UrlTree | boolean> => {
  const requestedUrl = next.url;
  const authFacade = inject(AuthFacade);
  const router = inject(Router);
  return authFacade.accessToken$.pipe(
    withLatestFrom(authFacade.currentUser$),
    // eslint-disable-next-line unused-imports/no-unused-vars
    mergeMap(([accessToken, currentUser]) => {
      // if (currentUser && !currentUser.passwordChanged) {
      //   snackbarService.open({
      //     text: `Vous n'avez pas défini de mot de passe. Veuillez consulter votre adresse mail.`
      //   });
      //   return authFacade.logout();
      // }
      return of({ accessToken, currentUser });
    }),
    map(data => {
      if (!data.accessToken || !data.currentUser?.isAdmin) {
        authFacade.setLastRequestedRoute(requestedUrl);
        return router.createUrlTree(['/auth/signin']);
      }
      return true;
    })
  );
};
